import { Outlet } from "react-router-dom";
import { Topbar } from "./Topbar";

export const StudentLayout = () => {
  return (
    <div className="min-h-screen bg-obsidian" data-testid="student-layout">
      <Topbar variant="student" showStudentNav={true} />
      <main className="min-h-[calc(100vh-64px)]">
        <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default StudentLayout;
